import { getLocalTimeZone, today } from "@internationalized/date";
import { useController, useFormContext } from "react-hook-form";
import { DatePickerInput } from "@/components/application/date-picker/date-picker-input";
import { Input } from "@/components/base/input/input";
import type { CreateCollabFormValues } from "../create-collab-group-modal";

const minActiveUntilDate = today(getLocalTimeZone()).add({ days: 1 });

export const DetailsStep1 = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<CreateCollabFormValues>();
  const { field: nameField } = useController({ name: "collaborationName", control });
  const { field: dateField } = useController({ name: "activeUntil", control });

  const setQuickDate = (days: number) => {
    const d = new Date();
    d.setDate(d.getDate() + days);
    setValue("activeUntil", d.toISOString().split("T")[0], { shouldValidate: true });
  };

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h3 className="text-base font-semibold text-primary">Collaboration Details</h3>
        <p className="text-sm text-tertiary mt-1">Fill in the details for your collaboration</p>
      </div>

      <Input label="Collaboration Type" defaultValue="Target" isDisabled size="md" />

      <Input
        label="Collaboration Name"
        isRequired
        size="md"
        isInvalid={!!errors.collaborationName}
        hint={errors.collaborationName?.message}
        {...nameField}
      />

      <div className="flex flex-col gap-2">
        <DatePickerInput
          label="Active Until"
          isRequired
          isInvalid={!!errors.activeUntil}
          hint={errors.activeUntil?.message}
          value={dateField.value}
          onChange={(v) => setValue("activeUntil", v ?? "", { shouldValidate: true })}
          minValue={minActiveUntilDate}
        />
        <div className="flex gap-2">
          {[
            { label: "14 Days", days: 14 },
            { label: "30 Days", days: 30 },
            { label: "90 Days", days: 90 },
          ].map(({ label, days }) => (
            <button
              key={label}
              type="button"
              onClick={() => setQuickDate(days)}
              className="px-3 py-1 text-xs font-medium text-secondary border border-secondary rounded-full hover:bg-secondary transition-colors"
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
